import { Tooltip } from '@material-ui/core';
import LocalDateFormatter, { LocalDateFormatType } from 'components/fomatter/local-date/local-date-formatter';
import DownloadIconButton from 'components/icon-buttons/download-icon-button/download-icon-button';

import Loading from 'components/loading/loading';
import { ShareholderDocumentsToGetAll } from 'model/shareholder-documents.model';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ShareholderDocumentTableProps {
    shareholderDocuments: ReadonlyArray<ShareholderDocumentsToGetAll>;
    isLoading: boolean;
    setSelectedDocumentId: (value: number) => void;
}

const I18N_PREFIX = 'shareholder-documents';

const ShareholderDocumentTable = (props: ShareholderDocumentTableProps) => {
    const { shareholderDocuments, isLoading, setSelectedDocumentId } = props;

    const { t } = useTranslation();

    const handleSelectedDocumentId = (id: number | undefined) => () => {
        if (!id) return;

        setSelectedDocumentId(id);
    };

    return (
        <>
            {isLoading && <Loading isTable />}
            {!isLoading && !shareholderDocuments?.length ? (
                <tr>
                    <td>
                        <div className="shareholder-documents--not-found">
                            <span className="shareholder-documents--not-found--icon" />
                            <h1>{t(`${I18N_PREFIX}.not-found`)}</h1>
                        </div>
                    </td>
                </tr>
            ) : (
                shareholderDocuments?.map(document => (
                    <tr className="page-container--table-cell" key={document.id}>
                        <td className="page-container--table-cell-title">
                            <Tooltip title={document?.issuerName ?? ''} interactive>
                                <span className="shareholder-documents--elipsis">{document?.issuerName}</span>
                            </Tooltip>
                        </td>
                        <td className="page-container--table-cell-title">
                            <LocalDateFormatter value={document?.documentDate} type={LocalDateFormatType.LONG_FULL_DATE} />
                        </td>
                        <td className="page-container--table-cell-title">
                            <span>{document?.calendarYear}</span>
                        </td>
                        <td className="page-container--table-cell-title">
                            <Tooltip title={document?.description ?? ''} interactive>
                                <span className="shareholder-documents--elipsis">{document?.description}</span>
                            </Tooltip>
                        </td>
                        <td className="page-container--table-cell-icon">
                            <DownloadIconButton onClick={handleSelectedDocumentId(document?.id)} />
                        </td>
                    </tr>
                ))
            )}
        </>
    );
};

export default ShareholderDocumentTable;
